module.exports = __webpack_public_path__ + "static/media/wordpress-sitebuildbuilder.0194a7e0.svg";